module.exports = {
      id: "messenger-usage",
      viewBox: "0 0 28 28",
      url: "/" + "svg-sprite-21c17c4d458cf2e2be6dd4c01f9ab03b.svg#messenger",
      toString: function () {
        return this.url;
      }
    }